<template>
  <div class="p-col-12">
    <page-header title="forms.stage.title" :actions="pageActions"/>
    <ancestryline-data-table :data-function="dataFunction" :columns="columns"/>
  </div>
</template>

<script>
import AncestrylineDataTable from "@/components/table/AncestrylineDataTable";
import FrontBusiness from "@/business/FrontBusiness";
import ToastMessageBusiness from "@/business/ToastMessageBusiness";
import PageHeader from "@/components/page/PageHeader";
import Audit from "@/viewer/user/Audit";
import StageBusiness from "@/business/StageBusiness";
import DialogService from "@/business/ModalBusiness";
import AncestrylineConfirmation from "@/components/dialog/AncestrylineConfirmation";

export default {
  name: "StageList",
  components: {PageHeader, AncestrylineDataTable},

  data() {
    return {
      dataFunction: StageBusiness.pagination,
      columns: [
        {field: "name", header: 'forms.stage.name', sortable:true},
        {field: "color", header: 'forms.stage.color', html: true, customFunction: this.colorSwatch, style: 'width: 100px'},
        {field: "created", header: 'forms.stage.created', sortable:true, type: 'date-time'},
        {field: "active", header: 'forms.stage.active', sortable:true, type: 'boolean'},
        {field: "actions", header: 'dataTable.actions', sortable:false, type: 'actions', style: 'width: 100px',
          actions: [
            {icon: 'pi pi-pencil', title: 'forms.stage.edit', function: this.editStage},
            {icon: 'pi pi-trash', title: 'forms.stage.delete', function: this.deleteStage, refreshList: true},
          ]
        },
      ],
      pageActions: [
        {icon: 'pi pi-plus', label: 'forms.stage.add', url: '/stage', type: 'link'},
        {icon: 'pi pi-eye', label: 'audit.button-list', function: this.openModal, type: 'button'},
      ],
    }
  },

  methods: {

    colorSwatch(stage){
      return StageBusiness.buildColorSwatchHtml(stage.color);
    },

    editStage(stage){
      FrontBusiness.redirect(`/stage/${stage.id}`);
    },

    async deleteStage(stage, dataList){
      if(await DialogService.openConfirmationModal(AncestrylineConfirmation)){
        const response = await StageBusiness.delete(stage.id).catch((e) => {
          if(e.stage_constraint){
            ToastMessageBusiness.showError(e.stage_constraint);
          } else {
            ToastMessageBusiness.showError(e.message);
          }
        });
        if(response){
          dataList = dataList.filter(c => c.id !== stage.id);
          ToastMessageBusiness.showSuccess();
        }
        return dataList;
      }
    },

    openModal(){
      DialogService.openModal(Audit, {business: StageBusiness});
    }

  }

}
</script>

<style scoped>

  ::v-deep .stage-color-dot {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    vertical-align: middle;
    border: 1px solid rgba(0, 0, 0, 0.15);
  }

</style>
